import { AuthService } from "../../../service/auth-service";
import { BifrostService } from "../../../service/bifrost-service";

const sendOTP = (mobile) => () => {
    return new Promise((resolve, reject) => {
        BifrostService.sendOtp(mobile)
            .then(response => resolve(response))
            .catch((error) => reject(error));
        // AuthService.sendOTP(mobile, "", c2bApiKey)
        //     .then(response => resolve(response))
        //     .catch(error => reject(error));
    });
};

const verifyOtp = (params) => () => {
    const otp = params?.otp;
    const mobileNumber = params?.phone_number;
    return new Promise((resolve, reject) => {
        BifrostService.verifyOtp(otp, mobileNumber, "+91", params?.partnerConsent ? { user_address_consent: params.partnerConsent } : {})
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

const login = (params, c2bApiKey = false) => () => {
    return new Promise((resolve, reject) => {
        AuthService.login(params, c2bApiKey)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

const logout = (token) => () => {
    return new Promise((resolve, reject) => {
        BifrostService.logout(token).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

const getUserDetails = () => () => {
    return new Promise((resolve, reject) => {
        AuthService.whoAmI()
            .then(response => {
                const { data: { data: { user } } } = response;
                // const { user_id: userId = "", token: secureToken} = user || {};
                resolve(user);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    sendOTP,
    verifyOtp,
    login,
    logout,
    getUserDetails
};
